import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleBestSpreadsheet from "../pages/articles/best-allchinabuy-spreadsheet-2026/page";
import ShoppingGuide from "../pages/articles/shopping-guide-2026/page";
import TrustedSellers from "../pages/articles/trusted-allchinabuy-sellers-2026/page";
import ShippingGuide from "../pages/articles/allchinabuy-shipping-guide-2026/page";
import QCGuide from "../pages/articles/allchinabuy-qc-guide-2026/page";
import BeginnersGuide from "../pages/articles/allchinabuy-beginners-guide-2026/page";
import VsCNFans from "../pages/articles/allchinabuy-vs-cnfans-2026/page";
import SneakersGuide from "../pages/articles/allchinabuy-sneakers-guide-2026/page";
import LuxuryBrands from "../pages/articles/allchinabuy-luxury-brands-2026/page";
import SafetyTips from "../pages/articles/allchinabuy-safety-tips-2026/page";
import BudgetFinds from "../pages/articles/allchinabuy-budget-finds-2026/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articles/best-allchinabuy-spreadsheet-2026",
    element: <ArticleBestSpreadsheet />,
  },
  {
    path: "/articles/shopping-guide-2026",
    element: <ShoppingGuide />,
  },
  {
    path: "/articles/trusted-allchinabuy-sellers-2026",
    element: <TrustedSellers />,
  },
  {
    path: "/articles/allchinabuy-shipping-guide-2026",
    element: <ShippingGuide />,
  },
  {
    path: "/articles/allchinabuy-qc-guide-2026",
    element: <QCGuide />,
  },
  {
    path: "/articles/allchinabuy-beginners-guide-2026",
    element: <BeginnersGuide />,
  },
  {
    path: "/articles/allchinabuy-vs-cnfans-2026",
    element: <VsCNFans />,
  },
  {
    path: "/articles/allchinabuy-sneakers-guide-2026",
    element: <SneakersGuide />,
  },
  {
    path: "/articles/allchinabuy-luxury-brands-2026",
    element: <LuxuryBrands />,
  },
  {
    path: "/articles/allchinabuy-safety-tips-2026",
    element: <SafetyTips />,
  },
  {
    path: "/articles/allchinabuy-budget-finds-2026",
    element: <BudgetFinds />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;